import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { ReportConfiguration, ReportConfigurationProduct, ReportConfigurationColumn } from '../model/interfaces/reportConfiguration.interface';
import {OrganizationCategory} from '../model/interfaces/organizationCategory.interface';
import { StandardDictionary } from "../model/interfaces/standarddictionary.interface";
import { TemplateListadoItem } from '../model/classes/templateListadoItem.class';
import { EntityChildsContext } from "app/private/entity/entityWithChilds/model/EntityChildsContext";

@Injectable()
export class ReportConfigurationService {
    private serviceUrl = 'api/reportConfiguration';
    private subscriptionUrl = 'api/ReportConfigurationSubscription';


    constructor(private http: Http, private sxHttp: SxHttpService) { }

    //#region standard persistence
    getAll(systemCode: string, businessCode: string): Observable<ReportConfiguration[]> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}`;
        return this.sxHttp.get(url).map(response => {
            const reports = response.json().data;
            return reports.map(report => report as ReportConfiguration);
        });
    }

    getTemplateList(systemCode: string, businessCode: string): Observable<TemplateListadoItem[]> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}`;
        return this.sxHttp.get(url).map(response => {
            const reports = response.json().data;
            return reports.map(report => {
                return {
                    id: report.id,
                    imagen: null,
                    titulo: report.name,
                    subtitulo: null,
                };
            });
        });
    }
    getByContext(systemCode: string, businessCode: string, reportCode: string): Observable<ReportConfiguration> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}/${reportCode}`;
        return this.sxHttp
            .get(url)
            .map(response => response.json().data as ReportConfiguration);
    }

    get(reportCode: string): Observable<ReportConfiguration> {
        const url = `${this.serviceUrl}/${reportCode}`;
        return this.sxHttp
            .get(url)
            .map(response =>{
                return response.json().data as ReportConfiguration
            });
    }

    save(report: ReportConfiguration): Promise<ReportConfiguration> {
        const url = `${this.serviceUrl}`;
        return this.sxHttp
            .post(url, report)
            .toPromise()
            .then(response => response.json().data as ReportConfiguration);
    }

    delete(systemCode: string, businessCode: string, reportCode: string): Promise<Boolean> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}/${reportCode}`;
        return this.sxHttp
            .delete(url)
            .toPromise()
            .then(result => result.json().data as Boolean);
    }

    getProductsAttributes(systemCode: string, businessCode: string): Observable<ReportConfigurationProduct[]> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}/productsAttributes`;
        return this.sxHttp.get(url).map(response => {
            const products = response.json().data;
            return products.map(report => report as ReportConfigurationProduct);
        });
    }
    //#endregion

    //#region columns

    getReportColumnsByContext(systemCode: string,businessCode: string, reportCode: string): Observable<ReportConfigurationColumn[]> {
        const url = this.serviceUrl + `/${systemCode}/${businessCode}/${reportCode}/column`;
        return this.sxHttp.get(url).map(response => response.json().data as ReportConfigurationColumn[]);
    }

    getColumnByContex(systemCode: string, businessCode: string,reportCode: string, mappingId: string): Observable<ReportConfigurationColumn> {
        const url = this.serviceUrl + `/${systemCode}/${businessCode}/${reportCode}/column/${mappingId}`;
        return this.sxHttp.get(url).map(response => response.json().data as ReportConfigurationColumn);
    }

    deleteColumn(column: ReportConfigurationColumn): Promise<Boolean> {
        const url = this.serviceUrl + `/${column.reportConfigurationId}/column/${column.id}`;
        return this.sxHttp
            .delete(url)
            .toPromise()
            .then(response => response.json().data as Boolean);
    }

    getReportColumns(reportCode: string): Observable<ReportConfigurationColumn[]> {
        const url = this.serviceUrl + `/${reportCode}/column`;
        return this.sxHttp.get(url).map(response => response.json().data as ReportConfigurationColumn[]);
    }

    getColumn(reportCode: string, mappingId: string): Observable<ReportConfigurationColumn> {
        const url = this.serviceUrl + `/${reportCode}/column/${mappingId}`;
        return this.sxHttp.get(url).map(response => response.json().data as ReportConfigurationColumn);
    }

    saveColumn(attribute: ReportConfigurationColumn): Promise<ReportConfigurationColumn> {
        const url = `${this.serviceUrl}/column`;
        return this.sxHttp
            .post(url, attribute)
            .toPromise()
            .then(response => response.json().data as ReportConfigurationColumn);
    }

    getCategory(): Observable<OrganizationCategory[]> {
        return this.sxHttp
            .get(this.serviceUrl + "/getorganizations")
            .map((response) => {
                return response.json().data as OrganizationCategory[];
            });
    }

    getStandardAttributes(standardDictionaries: StandardDictionary[],): Observable<string[]>{
        const url = this.serviceUrl + `/getStandardDictionaryAttributes`;
        return this.sxHttp.post(url, standardDictionaries).map(response => response.json().data as string[]);
    }

    getCommonDictionaries(): Observable<StandardDictionary[]>{
        const url = this.serviceUrl + `/getCommonDictionaries`;
        return this.sxHttp.get(url).map(response => response.json().data as StandardDictionary[]);
    }
    //#endregion


    //#region ReportConfiguration Subscriptions
    getAllWithContext(organizatinCode: string, 
                      subscriptionCode: string, 
                      channelCode: string,
                      productCode: string): Observable<ReportConfiguration[]> {
        const context: EntityChildsContext = {
        organizationCode: organizatinCode,
        subscriptionCode: subscriptionCode,
        channelCode: channelCode,
        productCode
        }
        return this.sxHttp
        .post(this.subscriptionUrl + '/GetReportConfiguration', context)
        .map((response) => response.json().data as ReportConfiguration[]);
        }

    getAllSubscribed(organizationCode: string,
                     subscriptionCode: string,
                     channelCode: string,
                     productCode: string
          ): Observable<ReportConfiguration[]> {
            let context: EntityChildsContext = {
              organizationCode: organizationCode,
              subscriptionCode: subscriptionCode,
              channelCode: channelCode,
              productCode: productCode,
            };
            return this.sxHttp
              .post(`${this.subscriptionUrl}/GetSubscription`, context)
              .map((response) => {
                return response.json().data as ReportConfiguration[];
              });
          }

    reportConfigurationSubscription(reportConfigurationSubscription): Observable<Boolean> {
        return this.sxHttp.post(`${this.subscriptionUrl}/Subscription`, reportConfigurationSubscription)
        .map((response) => {
            return response.json().data;
        });
    }

    unsubscribe(idReportConfiguration: string,
                organizationCode: string,
                subscriptionCode: string,
                channelCode: string,
                productCode: string): Promise<Boolean> {
        let context: EntityChildsContext = {
            organizationCode: organizationCode,
            subscriptionCode: subscriptionCode,
            channelCode: channelCode,
            productCode: productCode,
        };
        return this.sxHttp
          .post(this.subscriptionUrl + "/Delete" + "/" + idReportConfiguration, context)
          .toPromise()
          .then((result) => result.json().data);
      }
    //endregion
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/reportConfiguration.service.ts